import { setConfig } from './config';
import type { ImageEnhanceBatchTask } from './enhancer/type';
import type {
    EraserMethod,
    EraserParams,
    ImageEraserBatchTask,
    RecognizeParams,
    RecognizeResult,
    RecognizeTarget,
} from './eraser/type';
import type { Config } from './type';

export async function initConfig(config: Config) {
    setConfig(config);
}

export {
    eraser,
    recognize,
    recognizeAndEraser,
    eraserMethodFlow,
    triggerBackgroundAudit,
    clearAuditState,
    setEraserSensitiveCheck,
} from './eraser';
export { RecognizeTargetEnum } from './eraser/type';
export * from './eraser/error';
export { eraserBatch, recognizeBatch, eraserMethodFlowBatch } from './eraser/service';

export { getImageEnhanceResult, getImageEnhanceResultBatch } from './enhancer';

export type {
    Config,
    ImageEnhanceBatchTask,
    EraserMethod,
    EraserParams,
    ImageEraserBatchTask,
    RecognizeParams,
    RecognizeResult,
    RecognizeTarget,
};

export { ENHANCE_TYPE } from './enhancer/type';

export { rewriteImageAlpha, checkIsTransparentImage } from './utils/image';

export { segRecognizeMask } from './utils/canvas';

export { getImageMattingResult } from './matting/index';

export * from './matting/api';
export * from './matting/human-parsing';
export * from './matting/types';

export { retouching } from './retouching';
export * from './retouching/type';

export { getExpandResults, getExpandResultsByBatchID, deliverExpand, type ExpandResult } from './expand';
